import get from 'lodash/get';
import { normalize } from 'normalizr';
import { RSAA } from 'redux-api-middleware';
import { selectors } from 'app-webtech-core/selectors';
import { vodContent as vodContentSchemas } from 'app-webtech-core/schemas';
import { FETCH_ALL } from './types';
import { CATAGORIES_PER_PAGE, ITEMS_PER_PAGE } from '../constants';
import {
  refreshToken,
  appLaunchTrack as appLaunchTrackThunkAction,
} from '../../application/actions';

const { VodCategorySchema } = vodContentSchemas;

const addCategoryId = (categoryId) => (item) => ({
  ...item,
  categoryId,
});

const enhanceCategoryItems = (category) => ({
  ...category,
  items: category.items.map(addCategoryId(category._id)),
});

const vodContentFetchAllApiRequest = ({ page = 1, itemPage = 1 } = {}, baseUrl) => ({
  [RSAA]: {
    endpoint: `${baseUrl}/v3/vod/categories?includeItems=true&includeCategoryFields=imageFeatured,iconPng&itemOffset=${ITEMS_PER_PAGE}`,
    method: 'GET',
    credentials: 'same-origin',
    types: [
      {
        type: FETCH_ALL.REQUEST,
        meta: {
          params: {
            page,
            offset: CATAGORIES_PER_PAGE,
            itemPage,
            itemOffset: ITEMS_PER_PAGE,
          },
        },
      },
      {
        type: FETCH_ALL.SUCCESS,
        payload: async (action, state, res) => {
          const data = await res.json();

          const { categories, totalCategories, totalPages } = data;
          const enhancedCategories = categories.map(enhanceCategoryItems);
          const { result, entities } = normalize(enhancedCategories, [VodCategorySchema]);

          return {
            result,
            entities,
            totalCategories,
            totalPages,
          };
        },
        meta: {
          params: {
            page,
            offset: CATAGORIES_PER_PAGE,
            itemPage,
            itemOffset: ITEMS_PER_PAGE,
          },
        },
      },
      {
        type: FETCH_ALL.FAILURE,
        meta: {
          params: {
            page,
            offset: CATAGORIES_PER_PAGE,
            itemPage,
            itemOffset: ITEMS_PER_PAGE,
          },
        },
      },
    ],
  },
});

const requests = {};
const alreadyRequested = (params) => requests[JSON.stringify(params)];
const setRequested = (params) => {
  requests[JSON.stringify(params)] = true;
};
export const vodContentFetchAllApiRequestAction = ({
  page = 1,
  itemPage = 1,
  tryNumber = 0,
} = {}) => async (dispatch, getState) => {
  const state = getState();
  const vodUrl = selectors.application.servers(state).vod;
  const params = { page, itemPage };
  if (alreadyRequested(params)) {
    return;
  }

  const { payload = {}, error = false } = await dispatch(
    vodContentFetchAllApiRequest(params, vodUrl),
  );

  if (
    error &&
    payload.status === 401 &&
    get(payload, 'response.message', '').includes('expired token')
  ) {
    await dispatch(refreshToken({}));
    dispatch(vodContentFetchAllApiRequestAction({ ...params, tryNumber: tryNumber + 1 }));
    return;
  }

  setRequested(params);
  await dispatch(vodContentFetchAllApiRequest(params, vodUrl));
  dispatch(appLaunchTrackThunkAction(true));
};
